import { ChartData } from "../../dataset-window/models/types";
import { PlotDataEx } from "../interfaces";


export const configScatterChartData = (xData: ChartData, data: ChartData[], selectedColorPalette: Array<string>) => {
  const createPlotData = (d: ChartData, colorHex: string): PlotDataEx => {
    const hoverTemplateParts = [
      `<b>%{customdata|%Y-%m-%d %H:%M:%S}</b>`,
      `${xData.title}: <b>%{x:.3f}</b> ${xData.unit}`,
      `${d.title}: <b>%{y:.3f}</b> ${d.unit}`,
    ];

    const hoverTemplate = `${hoverTemplateParts.join("<br>")}<extra></extra>`;

    return {
      name: `${d.title}`,
      type: "scatter",
      mode: "markers",
      showlegend: true,
      unit: d.unit,
      hovertemplate: hoverTemplate,
      x: xData.valueArr,
      y: d.valueArr,
      opacity: 0.7,
      customdata: xData.keyArr,
      marker: {
        color: colorHex,
        size: 5,
      },
    } as PlotDataEx;
  };

  return data?.reduce((acc: Array< PlotDataEx>, curr: ChartData, index: number) => {
    if (curr !== undefined) {
      acc.push(createPlotData(curr, selectedColorPalette[index]));
    }
    return acc;
  }, []);
};
